import * as yup from 'yup';
import { emailArraySchema } from '../../../schemas/template-assignment-schema';
import { DataCollectionEmailPreferences } from '../../../data-models/preferences-v3.data-model';

const emailTemplateMessageSchema = () =>
  yup.object({
    subject: yup.string().max(200, 'Subject too long').optional(),
    header: yup.string().max(5000, 'Content too long').optional(),
    body: yup.string().max(10000, 'Content too long').optional(),
    contact: yup.string().optional(),
    signature: yup.string().optional(),
    footer: yup.string().optional(),
  });

export function dataCollectionEmailConfigFields() {
  return {
    ccEmails: emailArraySchema(
      yup
        .array()
        .of(yup.string())
        .nullable()
        .default([])
        .customMeta({
          description: 'CC email(s) that the data collection requests should always include',
        })
        .label('CC Emails')
    ),
    senderName: yup.string().optional().label('Sender Name'),
    senderEmail: yup.string().email('Must be a valid email').optional().label('Sender Email'),
    logoUrl: yup.string().url('Must be a valid URL').optional().label('Logo URL'),
    primaryColor: yup
      .string()
      .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Must be a valid hex color')
      .optional()
      .label('Primary Color'),
    secondaryColor: yup
      .string()
      .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Must be a valid hex color')
      .optional()
      .label('Secondary Color'),
    showHeader: yup.boolean().optional().label('Show Header'),
    showPendingRequestsCount: yup.boolean().optional().label('Show Pending Requests Count'),
    messages: yup
      .object({
        request: emailTemplateMessageSchema(),
        reminder: emailTemplateMessageSchema(),
      })
      .optional(),
  };
}

export function dataCollectionEmailConfigSchema() {
  return yup.object(dataCollectionEmailConfigFields());
}

export function generalSettingsSchema() {
  const fields = dataCollectionEmailConfigFields();
  return yup.object({
    ccEmails: fields.ccEmails,
    senderName: fields.senderName,
  });
}

export function createDataCollectionEmailConfig(
  overrides: Partial<DataCollectionEmailPreferences> = {}
): DataCollectionEmailPreferences {
  return {
    ccEmails: [],
    senderName: undefined,
    senderEmail: undefined,
    logoUrl: undefined,
    primaryColor: undefined,
    secondaryColor: undefined,
    showHeader: false,
    showPendingRequestsCount: false,
    messages: {
      request: { subject: '', header: '', body: '', contact: '', signature: '', footer: '' },
      reminder: { subject: '', header: '', body: '', contact: '', signature: '', footer: '' },
    },
    ...overrides,
  };
}
